module.exports = __webpack_public_path__ + "img/login_slogan_en.8c647a50.png";